export default __webpack_public_path__ + "static/media/agentsMngrs.76a8bc08.jpg";